<div>
<div>
<div>
<div>
<div class="panel panel-table">
<div class="panel-heading">
<h3 class="panel-title"><strong>DATA INTEGRATION TOOLKIT WEBSITE</strong></h3>
</div>
<div class="d-flex panel-body fixed-panel">
<div class="col-sm" style="float:left">

<p><i>This web site is designed to allow you to explore the Data Integration Toolkit to understand its
wide range of capabilities.</i></p>

<strong>Real-time Access to D&amp;B Data</strong>

<p>The Data Integration Toolkit™ (Toolkit) is an interface designed to enable access to global
D&amp;B
data in real-time. Toolkit takes the complexity out of integrating data across systems and
applications
and offers the most flexible and cost-effective way
to access and embed D&amp;B's global data into your enterprise-wide business applications. With the
Data
Integration Toolkit, you gain access to over 180 million business records, driven by the power of
D&amp;B's proprietary and patent-pending
<a aria-label="Link to Dnb info quality" target="_blank" href="http://www.dnb.com/us/about/db_database/dnbinfoquality.html">DUNSRight®</a> process,
enabling
you to increase the speed and accuracy of your organization's decision making.</p>
<p>The Data Integration Toolkit is easy to install and integrate, offering:</p>
<ul>
<li>Access to D&amp;B's global data</li>
<li>An XML-based Delivery Technology</li>
<li>Professional Service &amp; Support</li>
<li>Pre-integrated Solutions compatible with leading ERP, CRM and e-Commerce providers including Oracle and SAP</li>
</ul>
<strong>Unparalleled Global Expertise in Managing Data</strong>
<p>The Data Integration ToolkitTMalso provides a solution to one of the most challenging aspects of
data integration - the ability to obtain consistent data from around the world, which minimizes local and
regional differences, via one unified platform. Translate
and share information in a choice of languages saving on the cost of managing multiple information
sources, and you can improve the accuracy and efficiency of your decision making processes wherever
you are doing business.</p>
<p>With the Data Integration Toolkit you do not change the way you do business. You just make better
decisions because you have real-time access to information that helps you Decide with Confidence.
</p>
<p>Click on <a aria-label="Solutions" [routerLink]="'/unlocked/solutions-home'">Solutions</a> to obtain more detailed information.If you are
already a customer, click on <a aria-label="Technology" [routerLink]="'/unlocked/technology'">Technology</a> to download the API, technical documentation, and data format
information. For service availability information and technical support information, select <a aria-label="Support" role="link" [routerLink]="'/unlocked/support'">Support.</a></p>
<br>



<p><a aria-label="Top" tabindex=0 role=link (click)="Top()">top</a></p>

</div>
<right-box></right-box>
</div>
</div>
</div>
</div>
</div>
</div>